import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c(VSnackbar,{attrs:{"value":_vm.snackbar,"color":_vm.snackbarColor,"dark":""},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c(VBtn,_vm._b({attrs:{"text":""},on:{"click":_vm.closeSnackbar}},'v-btn',attrs,false),[_vm._v(" Close ")])]}}])},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.snackbarText))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }